// use jquery from wordpress. place in module if needed
window.$ = window.jQuery = jQuery;

import { afterScroll } from './helpers/utils.js';
import { lazy } from './helpers/lazyLoading';
import { classtoggler } from 'classtoggler';
import axios from 'axios';
import lottie from 'lottie-web';
import panoramaConfig from './panorama.config';
import { Modal } from './modules/modal.js';
import { initActorsFilter } from './modules/actors-filter.js';
import { initTalentTabs, initTalentHeroSlider, initVitaShowMore } from './modules/talent-tabs.js';
import { initGalleryLightbox } from './modules/gallery-lightbox.js';
import { initNewsLoadMore } from './modules/news-load-more.js';
import { initTeamModal } from './modules/team-modal.js';
import { initCookieConsent } from './modules/cookie-consent.js';
import { initVideoPlayers } from './modules/video-player.js';
import { initVideoPreviewAdmin } from './modules/video-preview-admin.js';
import animationData from '../img/sk_animation_v2.json';

//*******************************************************
// sticky navigation
//*******************************************************

afterScroll(() => {
   if (window.scrollY > 0) {
      document.body.classList.add('scroll');
   } else {
      document.body.classList.remove('scroll');
   }
});

//*******************************************************
// panorama intro — lottie animation
//*******************************************************

const lottieContainer = document.querySelector('.panorama__lottie');
const panoramaIntro = document.querySelector('.panorama__intro');

if (lottieContainer && panoramaIntro) {
   const anim = lottie.loadAnimation({
      container: lottieContainer,
      renderer: 'svg',
      loop: false,
      autoplay: false,
      animationData,
   });

   anim.setSpeed(panoramaConfig.animationSpeed);

   // Start only after the page-load fade-in (#wrapper transition) is complete
   const wrapper = document.querySelector('#wrapper');
   const startAnim = () => anim.play();
   if (wrapper) {
      wrapper.addEventListener('transitionend', startAnim, { once: true });
   } else {
      window.addEventListener('load', startAnim);
   }

   let faded = false;
   const fadeOutIntro = () => {
      if (faded) return;
      faded = true;
      panoramaIntro.style.animation = 'none'; // cancel CSS fadeIn fill-mode so opacity is writable
      panoramaIntro.style.opacity = '1';
      requestAnimationFrame(() => {
         panoramaIntro.style.transition = `opacity ${panoramaConfig.fadeOutDuration}ms ${panoramaConfig.fadeOutEasing}`;
         requestAnimationFrame(() => {
            panoramaIntro.style.opacity = '0';
         });
      });
      panoramaIntro.addEventListener(
         'transitionend',
         () => {
            panoramaIntro.style.display = 'none';
            document.body.classList.add('intro-done');
         },
         { once: true }
      );
   };

   // getDuration-based timeout is the primary trigger; 'complete' event as fallback
   anim.addEventListener('DOMLoaded', () => {
      const animDuration = (anim.getDuration() / panoramaConfig.animationSpeed) * 1000;
      setTimeout(fadeOutIntro, animDuration + panoramaConfig.fadeOutDelay);
   });
   anim.addEventListener('complete', () => setTimeout(fadeOutIntro, panoramaConfig.fadeOutDelay));
}

//*******************************************************
// panorama slideshow autoplay
//*******************************************************

const panoramaSlides = [...document.querySelectorAll('.panorama__slide')];
if (panoramaSlides.length > 1) {
   let current = 0;
   setInterval(() => {
      panoramaSlides[current].classList.remove('is-active');
      current = (current + 1) % panoramaSlides.length;
      panoramaSlides[current].classList.add('is-active');
   }, 4000);
}

//*******************************************************
// page load fade in
//*******************************************************

window.addEventListener('load', () => {
   const wrapper = document.querySelector('body');
   wrapper.classList.add('loaded');
});

//*******************************************************
// classtoggler
// use for class toggling via click in the markup
// https://www.npmjs.com/package/classtoggler/v/1.3.3
//*******************************************************

classtoggler();

//*******************************************************
// lazy loading
//*******************************************************

lazy();

//*******************************************************
// ACTORS PAGE
//*******************************************************

initActorsFilter();
initTalentTabs();
initTalentHeroSlider();
initVitaShowMore();
initGalleryLightbox();
initNewsLoadMore();
// initParallax();
initTeamModal();
initCookieConsent();
initVideoPlayers();
initVideoPreviewAdmin();

//*******************************************************
// FRONTPAGE
//*******************************************************

const asyncBtn = document.querySelector('.js-asyncPostGet');
if (asyncBtn) {
   // prepare a modal to show the async data in it
   const modal = new Modal();

   asyncBtn.addEventListener('click', () => {
      const data = new FormData();
      data.append('action', 'ajax_get_post');
      data.append('postID', 1);
      asyncBtn.classList.add('btn--loading');
      axios.post(settings.ajaxurl, data).then((response) => {
         console.log(response);
         asyncBtn.classList.remove('btn--loading');
         modal.open();
         modal.loadContent(`
            <div class="p-3">
               <div class="bg-fourth p-3">
                  <p>Woooow you just fetched the post ID: ${response.data.id}</p>
                  <p>opened a modal</p>
                  <p>and loaded some post data into it</p>
                  <p>like the title: <strong>${response.data.title}</strong></p>
               </div>
            </div>
         `);
      });
   });
}
